import React, { createContext, useContext, useState } from "react";

const dict = {
  fr: {
    // Nav
    nav_browse: "Explorer", nav_categories: "Catégories", nav_providers: "Prestataires",
    nav_how: "Comment ça marche", nav_login: "Se connecter", nav_signup: "S'inscrire",
    nav_dashboard: "Tableau de bord", nav_logout: "Déconnexion", nav_profile: "Profil",
    // Hero
    hero_title: "Découvrez des professionnels français d'exception aux États-Unis",
    hero_subtitle: "The French Touch, Right at Your Door.",
    hero_search_placeholder: "Rechercher un service...",
    hero_location_placeholder: "Ville",
    hero_category_placeholder: "Catégorie",
    search_btn: "Rechercher",
    // CTAs & sections
    cta_customer: "Réservez un service", cta_provider: "Devenir prestataire",
    how_title: "Comment ça marche", how_subtitle: "Trois étapes simples, pas d'intermédiaire.",
    step_discover: "Découvrez", step_discover_d: "Parcourez les catégories et comparez les prestataires vérifiés.",
    step_book: "Réservez", step_book_d: "Choisissez votre créneau et payez en toute sécurité.",
    step_enjoy: "Profitez", step_enjoy_d: "Bénéficiez du service, puis laissez un avis.",
    popular_cats: "Catégories populaires", featured_services: "Services en vedette",
    featured_providers: "Prestataires recommandés",
    trust_title: "Une place de marché de confiance",
    trust_1_t: "Prestataires vérifiés", trust_1_d: "Chaque profil est approuvé par notre équipe.",
    trust_2_t: "Paiement sécurisé", trust_2_d: "Vos transactions sont protégées de bout en bout.",
    trust_3_t: "Avis authentiques", trust_3_d: "Uniquement des avis de clients réels après un service complété.",
    dual_customer_h: "Trouvez le bon expert.", dual_customer_d: "Parcourez, comparez, réservez — le tout au même endroit.",
    dual_provider_h: "Développez votre activité.", dual_provider_d: "Rejoignez une communauté de professionnels indépendants.",
    // Cards / generic
    book_now: "Réserver", view_profile: "Voir le profil", view_all: "Voir tout",
    price_from: "à partir de", per_service: "par prestation", reviews: "avis",
    loading: "Chargement...", back: "Retour", save: "Enregistrer", cancel: "Annuler",
    delete: "Supprimer", edit: "Éditer", approve: "Approuver", reject: "Rejeter",
    // Auth
    login_title: "Bon retour", signup_title: "Créer un compte",
    email: "E-mail", password: "Mot de passe", full_name: "Nom complet",
    i_am: "Je suis un(e)", customer: "Client", provider: "Prestataire",
    login_google: "Continuer avec Google", or: "ou",
    already_account: "Déjà un compte ?", no_account: "Pas encore de compte ?",
    welcome_toast: "Bienvenue !",
    // Services page
    explore_services: "Explorer les services", explore_sub: "Trouvez le bon prestataire près de chez vous.",
    search_ph: "Rechercher...", all_cats: "Toutes catégories",
    sort_recent: "Plus récent", sort_price_asc: "Prix croissant", sort_price_desc: "Prix décroissant",
    no_services: "Aucun service trouvé.",
    // Service detail
    provider: "Prestataire", years_exp: "ans d'expérience", duration_min: "min",
    pick_date: "Choisir une date", time: "Heure", notes_opt: "Notes (optionnel)",
    booking_in_progress: "Réservation...", secure_pay: "Paiement sécurisé · Annulation flexible",
    // Dashboards
    hello: "Bonjour", track_bookings: "Suivez vos réservations et laissez des avis.",
    my_bookings: "Mes réservations", bookings: "Réservations", upcoming: "À venir",
    completed: "Complétées", no_bookings: "Aucune réservation.", explore_link: "Explorer les services",
    leave_review: "Laisser un avis", your_review: "Votre avis", publish_review: "Publier l'avis",
    share_exp: "Partagez votre expérience...", with_who: "avec",
    // Provider dashboard
    provider_dash: "Tableau prestataire", welcome: "Bienvenue",
    new_service: "Nouveau service", total_revenue: "Revenus totaux",
    after_commission: "Après commission plateforme", active_services: "Services actifs",
    completed_jobs: "Prestations réalisées",
    tab_overview: "Vue d'ensemble", tab_services: "Mes services", tab_bookings: "Réservations",
    overview_hint: "Consultez vos statistiques, gérez vos services et acceptez les réservations depuis les onglets.",
    no_services_click: "Aucun service. Cliquez sur \"Nouveau service\".",
    pending_approval_msg: "Votre profil prestataire est en cours de vérification par notre équipe.",
    pending_approval_title: "Compte en attente d'approbation",
    title_label: "Titre", description: "Description", category: "Catégorie",
    city: "Ville", price_eur: "Prix ($ USD)", duration_lbl: "Durée (min)", image_url: "Image URL",
    received: "reçus", confirm_delete: "Supprimer ce service ?",
    service_created: "Service créé (en attente d'approbation)",
    service_updated: "Service mis à jour",
    // Admin
    admin_title: "Administration", users: "Utilisateurs", services: "Services",
    settings: "Paramètres", revenue: "Chiffre d'affaires",
    rt_commission: "Commission Refine Touch", rate: "Taux",
    pending_approvals: "Approbations en attente",
    pending_providers_x: "prestataires à approuver", pending_services_x: "services à approuver",
    provider_payouts: "Payouts prestataires",
    commission_label: "Commission plateforme (0-1)",
    commission_saved: "Commission mise à jour",
    active: "actif", pending: "en attente",
    // Categories / providers
    cats_title: "Catégories", our_providers: "Nos prestataires",
    services_count: "services", ratings_count: "avis",
    // How it works
    how_page_title: "Comment ça marche",
    for_customers: "Pour les clients", for_providers: "Pour les prestataires",
    hw_c1_t: "Découvrez", hw_c1_d: "Parcourez les catégories, filtrez par prix, ville ou note.",
    hw_c2_t: "Réservez", hw_c2_d: "Choisissez votre créneau et payez en sécurité.",
    hw_c3_t: "Profitez", hw_c3_d: "Recevez le service et laissez votre avis.",
    hw_p1_t: "Créez votre profil", hw_p1_d: "Présentez vos compétences et votre portfolio.",
    hw_p2_t: "Publiez vos services", hw_p2_d: "Prix, durée, disponibilités — vous décidez.",
    hw_p3_t: "Recevez vos paiements", hw_p3_d: "Refine Touch prélève 15%, vous encaissez le reste.",
    // Profile
    my_profile: "Mon profil", name: "Nom", phone: "Téléphone", bio: "Bio",
    // Payment
    demo_mode: "MODE DÉMO", mock_pay_title: "Paiement simulé",
    mock_pay_desc: "Stripe n'est pas encore connecté. Confirmez pour simuler un paiement réussi.",
    confirm_pay: "Confirmer le paiement", processing: "Traitement...",
    pay_confirmed: "Paiement confirmé !",
    // Footer
    footer_tag: "La marketplace des professionnels indépendants.",
    footer_discover: "Découvrir", footer_help: "Aide", footer_legal: "Légal",
    become_provider: "Devenir prestataire",
    // Provider profile
    services_offered: "Services proposés", customer_reviews: "Avis clients",
    no_reviews: "Aucun avis pour l'instant.", jobs_done: "prestations réalisées",
    // Errors
    err_generic: "Erreur", err_booking: "Erreur lors de la réservation",
    review_published: "Avis publié !",
    google_connected: "Connecté via Google", connecting: "Connexion...",
    delete_short: "Suppr.", clients_label: "Clients", providers_label: "Prestataires",
    customers_hint: "clients", providers_hint: "prestataires",
    completed_hint: "complétées", suppr: "Suppr.",
    new_label: "Nouveau", edit_label: "Éditer",
    // US map
    cities_title: "Nos professionnels français à travers les États-Unis",
    cities_subtitle: "Sélectionnez une ville pour découvrir les prestataires disponibles.",
    coming_soon: "Bientôt disponible",
    pros_in: "prestataires à",
    banner_florida: "Le savoir-faire français, sous le soleil de Floride.",
    // Legal
    legal_terms: "Conditions d'utilisation",
    legal_privacy: "Politique de confidentialité",
    legal_cookies: "Politique cookies",
    last_updated: "Dernière mise à jour",
    contact_us_at: "Pour toute question, contactez-nous à",
    // How-it-works quick actions
    hw_customer_cta: "Explorer les services",
    hw_customer_signup: "Créer un compte",
    hw_provider_cta: "Devenir prestataire",
    hw_provider_signin: "J'ai déjà un compte",
    // Provider requests (admin)
    pr_tab: "Demandes prestataires", pr_title: "Demandes de profil prestataire",
    pr_subtitle: "Examinez chaque candidature et activez les profils dignes de Refine Touch.",
    pr_pending: "En attente", pr_accepted: "Acceptées", pr_refused: "Refusées", pr_all: "Toutes",
    pr_accept: "Accepter", pr_refuse: "Refuser", pr_requested_on: "Demande du",
    pr_reviewed_on: "Traitée le", pr_services: "Services proposés", pr_description: "Description",
    pr_location: "Localisation", pr_experience: "ans d'expérience", pr_no_location: "Non renseignée",
    pr_no_bio: "Aucune description fournie.", pr_none: "Aucune demande pour ce filtre.",
    pr_confirm_accept_t: "Accepter cette candidature ?",
    pr_confirm_accept_d: "Le profil de {name} deviendra immédiatement visible et actif sur le site.",
    pr_confirm_refuse_t: "Refuser cette candidature ?",
    pr_confirm_refuse_d: "Le profil de {name} sera rejeté. Vous pouvez indiquer un motif (facultatif) qui sera visible par le prestataire.",
    pr_reason_label: "Motif du refus (facultatif)",
    pr_reason_ph: "Ex. : Merci de compléter votre description et d'ajouter une photo professionnelle.",
    pr_accepted_toast: "Profil accepté et activé", pr_refused_toast: "Candidature refusée",
    pr_new_badge: "nouvelles", pr_reason: "Motif", pr_listed: "Services publiés",
    pr_status_pending: "En attente", pr_status_approved: "Acceptée", pr_status_rejected: "Refusée",
    cancel: "Annuler", confirm: "Confirmer",
    // Provider signup extras
    ps_section: "Votre profil professionnel",
    ps_hint: "Ces informations seront examinées par Refine Touch USA avant l'activation de votre profil.",
    ps_photo: "Photo (URL)", ps_location: "Ville, État", ps_bio: "Présentez-vous",
    ps_bio_ph: "Votre parcours, votre spécialité, ce qui rend votre service unique...",
    ps_services: "Services proposés", ps_services_ph: "Chef privé, Cours de pâtisserie, Traiteur (séparés par des virgules)",
    ps_experience: "Années d'expérience", ps_website: "Site web", ps_instagram: "Instagram",
    // Provider rejection
    rejected_title: "Candidature non retenue",
    rejected_msg: "Votre profil prestataire n'a pas été accepté pour le moment.",
    rejected_reason: "Motif communiqué",
    rejected_resubmit_hint: "Mettez à jour votre profil ci-dessous puis soumettez à nouveau votre candidature.",
    resubmit: "Soumettre à nouveau", resubmitted: "Candidature envoyée — en cours d'examen.",
    upload_photo: "Photo de profil", upload_hint: "JPG, PNG ou WEBP · 5 Mo max",
    upload_ok: "Photo mise à jour", upload_type_err: "Veuillez choisir une image",
    upload_size_err: "L'image doit faire moins de 5 Mo",
    // Social proof / trust
    rating_new: "Nouveau", verified: "Vérifié", verified_tip: "Identité et qualifications vérifiées par Refine Touch USA",
    testimonials_title: "Ce que disent nos clients", testimonials_sub: "Des avis réels de clients américains ayant réservé des experts français via Refine Touch.",
    about_service: "À propos de", vetted_title: "Rencontrez nos pros vérifiés",
    vetted_sub: "Chaque prestataire est sélectionné à la main : identité, diplômes, assurances et avis sont vérifiés avant publication.",
    vetted_1_t: "Identité vérifiée", vetted_1_d: "Pièce d'identité et autorisation de travail aux États-Unis contrôlées pour chaque prestataire.",
    vetted_2_t: "Savoir-faire français", vetted_2_d: "Formation, diplômes et références professionnelles examinés par notre équipe.",
    vetted_3_t: "Paiement protégé", vetted_3_d: "Vous payez en toute sécurité et le prestataire n'est réglé qu'une fois la prestation réalisée.",
    vetted_4_t: "Satisfaction garantie", vetted_4_d: "Annulation flexible et remboursement selon notre politique en cas de problème.",
    stats_providers: "experts vérifiés", stats_reviews: "avis clients", stats_rating: "note moyenne", stats_bookings: "prestations réalisées",
    partners_title: "Nos partenaires", partners_sub: "Ils nous font confiance et soutiennent la communauté française aux États-Unis.",
    faq_title: "Questions fréquentes",
    faq_1_q: "Comment les prestataires sont-ils vérifiés ?", faq_1_a: "Chaque candidature est examinée manuellement par notre équipe : identité, qualifications, expérience et portfolio. Seuls les profils validés apparaissent sur le site.",
    faq_2_q: "Dans quelle devise sont affichés les prix ?", faq_2_a: "Tous les prix sont en dollars américains (USD), taxes applicables incluses sauf mention contraire.",
    faq_3_q: "Puis-je annuler une réservation ?", faq_3_a: "Oui. L'annulation est gratuite jusqu'à 48 h avant la prestation. Consultez notre politique d'annulation et de remboursement pour les détails.",
    faq_4_q: "Quand le prestataire est-il payé ?", faq_4_a: "Votre paiement est sécurisé par Refine Touch et reversé au prestataire une fois la prestation réalisée. Refine Touch prélève une commission de 15 %.",
    faq_5_q: "Les prestataires parlent-ils anglais ?", faq_5_a: "Oui, tous nos experts sont bilingues français / anglais afin de vous accompagner dans la langue de votre choix.",
    legal_refund: "Annulation & remboursement",
    popular_searches: "Recherches populaires", hero_location_all: "Toutes les villes",
    book_service_top: "Réserver un service", notify_title: "Votre ville n'est pas encore disponible ?",
    notify_sub: "Laissez votre email et nous vous préviendrons dès l'ouverture dans votre ville.",
    notify_city_ph: "Choisir une ville", notify_email_ph: "votre@email.com", notify_btn: "Me prévenir",
    notify_ok: "Merci ! Nous vous préviendrons dès l'ouverture.", notify_err: "Veuillez saisir un email valide et une ville.",
    waitlist_tab: "Liste d'attente", waitlist_title: "Inscriptions « Me prévenir »", waitlist_none: "Aucune inscription pour le moment.",
    waitlist_city: "Ville", waitlist_email: "Email", waitlist_date: "Date",
  },
  en: {
    nav_browse: "Browse", nav_categories: "Categories", nav_providers: "Providers",
    nav_how: "How it works", nav_login: "Sign in", nav_signup: "Sign up",
    nav_dashboard: "Dashboard", nav_logout: "Log out", nav_profile: "Profile",
    hero_title: "French Professionals & Services in the USA",
    hero_subtitle: "The French Touch, Right at Your Door.",
    hero_search_placeholder: "Search a service...",
    hero_location_placeholder: "City",
    hero_category_placeholder: "Category",
    search_btn: "Search",
    cta_customer: "Book a service", cta_provider: "Become a provider",
    how_title: "How it works", how_subtitle: "Three simple steps, no middleman.",
    step_discover: "Discover", step_discover_d: "Browse categories and compare vetted professionals.",
    step_book: "Book", step_book_d: "Pick your slot and pay securely.",
    step_enjoy: "Enjoy", step_enjoy_d: "Get the service, then leave a review.",
    popular_cats: "Popular categories", featured_services: "Featured services",
    featured_providers: "Recommended providers",
    trust_title: "A trustworthy marketplace",
    trust_1_t: "Vetted providers", trust_1_d: "Every profile is reviewed by our team.",
    trust_2_t: "Secure payments", trust_2_d: "Your transactions are protected end-to-end.",
    trust_3_t: "Real reviews", trust_3_d: "Only from customers with completed bookings.",
    dual_customer_h: "Find the right expert.", dual_customer_d: "Browse, compare, book — all in one place.",
    dual_provider_h: "Grow your business.", dual_provider_d: "Join a community of independent professionals.",
    book_now: "Book", view_profile: "View profile", view_all: "See all",
    price_from: "from", per_service: "per service", reviews: "reviews",
    loading: "Loading...", back: "Back", save: "Save", cancel: "Cancel",
    delete: "Delete", edit: "Edit", approve: "Approve", reject: "Reject",
    login_title: "Welcome back", signup_title: "Create your account",
    email: "Email", password: "Password", full_name: "Full name",
    i_am: "I am a", customer: "Customer", provider: "Provider",
    login_google: "Continue with Google", or: "or",
    already_account: "Already have an account?", no_account: "New to Refine Touch?",
    welcome_toast: "Welcome!",
    explore_services: "Explore services", explore_sub: "Find the right pro near you.",
    search_ph: "Search...", all_cats: "All categories",
    sort_recent: "Most recent", sort_price_asc: "Price: low to high", sort_price_desc: "Price: high to low",
    no_services: "No services found.",
    provider: "Provider", years_exp: "years of experience", duration_min: "min",
    pick_date: "Pick a date", time: "Time", notes_opt: "Notes (optional)",
    booking_in_progress: "Booking...", secure_pay: "Secure payment · Flexible cancellation",
    hello: "Hello", track_bookings: "Track your bookings and leave reviews.",
    my_bookings: "My bookings", bookings: "Bookings", upcoming: "Upcoming",
    completed: "Completed", no_bookings: "No bookings yet.", explore_link: "Browse services",
    leave_review: "Leave a review", your_review: "Your review", publish_review: "Publish review",
    share_exp: "Share your experience...", with_who: "with",
    provider_dash: "Provider dashboard", welcome: "Welcome",
    new_service: "New service", total_revenue: "Total revenue",
    after_commission: "After platform commission", active_services: "Active services",
    completed_jobs: "Completed jobs",
    tab_overview: "Overview", tab_services: "My services", tab_bookings: "Bookings",
    overview_hint: "Check stats, manage services and accept bookings from the tabs.",
    no_services_click: "No services yet. Click \"New service\".",
    pending_approval_msg: "Your provider profile is being reviewed by our team.",
    pending_approval_title: "Account pending approval",
    title_label: "Title", description: "Description", category: "Category",
    city: "City", price_eur: "Price ($ USD)", duration_lbl: "Duration (min)", image_url: "Image URL",
    received: "received", confirm_delete: "Delete this service?",
    service_created: "Service created (pending approval)",
    service_updated: "Service updated",
    admin_title: "Administration", users: "Users", services: "Services",
    settings: "Settings", revenue: "Revenue",
    rt_commission: "Refine Touch commission", rate: "Rate",
    pending_approvals: "Pending approvals",
    pending_providers_x: "providers to approve", pending_services_x: "services to approve",
    provider_payouts: "Provider payouts",
    commission_label: "Platform commission (0-1)",
    commission_saved: "Commission updated",
    active: "active", pending: "pending",
    cats_title: "Categories", our_providers: "Our providers",
    services_count: "services", ratings_count: "reviews",
    how_page_title: "How it works",
    for_customers: "For customers", for_providers: "For providers",
    hw_c1_t: "Discover", hw_c1_d: "Browse categories, filter by price, city or rating.",
    hw_c2_t: "Book", hw_c2_d: "Pick your slot and pay securely.",
    hw_c3_t: "Enjoy", hw_c3_d: "Get the service and leave your review.",
    hw_p1_t: "Create your profile", hw_p1_d: "Showcase your skills and portfolio.",
    hw_p2_t: "Publish your services", hw_p2_d: "Price, duration, availability — you decide.",
    hw_p3_t: "Get paid", hw_p3_d: "Refine Touch takes 15%, you keep the rest.",
    my_profile: "My profile", name: "Name", phone: "Phone", bio: "Bio",
    demo_mode: "DEMO MODE", mock_pay_title: "Simulated payment",
    mock_pay_desc: "Stripe is not connected yet. Confirm to simulate a successful payment.",
    confirm_pay: "Confirm payment", processing: "Processing...",
    pay_confirmed: "Payment confirmed!",
    footer_tag: "The marketplace for independent professionals.",
    footer_discover: "Discover", footer_help: "Help", footer_legal: "Legal",
    become_provider: "Become a provider",
    services_offered: "Services offered", customer_reviews: "Customer reviews",
    no_reviews: "No reviews yet.", jobs_done: "jobs completed",
    err_generic: "Error", err_booking: "Booking error",
    review_published: "Review published!",
    google_connected: "Signed in with Google", connecting: "Signing in...",
    delete_short: "Del.", clients_label: "For customers", providers_label: "For providers",
    customers_hint: "customers", providers_hint: "providers",
    completed_hint: "completed", suppr: "Del.",
    new_label: "New", edit_label: "Edit",
    // US map
    cities_title: "Our French professionals across the USA",
    cities_subtitle: "Pick a city to discover available providers.",
    coming_soon: "Coming soon",
    pros_in: "pros in",
    banner_florida: "French craftsmanship, under the Florida sun.",
    // Legal
    legal_terms: "Terms of Service",
    legal_privacy: "Privacy Policy",
    legal_cookies: "Cookie Policy",
    last_updated: "Last updated",
    contact_us_at: "For any question, contact us at",
    // How-it-works quick actions
    hw_customer_cta: "Browse services",
    hw_customer_signup: "Create an account",
    hw_provider_cta: "Become a provider",
    hw_provider_signin: "I already have an account",
    // Provider requests (admin)
    pr_tab: "Provider Requests", pr_title: "Provider profile requests",
    pr_subtitle: "Review each application and activate the profiles worthy of Refine Touch.",
    pr_pending: "Pending", pr_accepted: "Accepted", pr_refused: "Refused", pr_all: "All",
    pr_accept: "Accept", pr_refuse: "Refuse", pr_requested_on: "Requested on",
    pr_reviewed_on: "Reviewed on", pr_services: "Services offered", pr_description: "Description",
    pr_location: "Location", pr_experience: "years of experience", pr_no_location: "Not provided",
    pr_no_bio: "No description provided.", pr_none: "No requests for this filter.",
    pr_confirm_accept_t: "Accept this application?",
    pr_confirm_accept_d: "{name}'s profile will immediately become visible and active on the site.",
    pr_confirm_refuse_t: "Refuse this application?",
    pr_confirm_refuse_d: "{name}'s profile will be rejected. You may add a reason (optional) that the provider will see.",
    pr_reason_label: "Refusal reason (optional)",
    pr_reason_ph: "E.g. Please complete your description and add a professional photo.",
    pr_accepted_toast: "Profile accepted and activated", pr_refused_toast: "Application refused",
    pr_new_badge: "new", pr_reason: "Reason", pr_listed: "Listed services",
    pr_status_pending: "Pending", pr_status_approved: "Accepted", pr_status_rejected: "Refused",
    cancel: "Cancel", confirm: "Confirm",
    // Provider signup extras
    ps_section: "Your professional profile",
    ps_hint: "This information will be reviewed by Refine Touch USA before your profile goes live.",
    ps_photo: "Photo (URL)", ps_location: "City, State", ps_bio: "Introduce yourself",
    ps_bio_ph: "Your background, your specialty, what makes your service unique...",
    ps_services: "Services offered", ps_services_ph: "Private chef, Pastry classes, Catering (comma separated)",
    ps_experience: "Years of experience", ps_website: "Website", ps_instagram: "Instagram",
    // Provider rejection
    rejected_title: "Application not accepted",
    rejected_msg: "Your provider profile has not been accepted at this time.",
    rejected_reason: "Reason provided",
    rejected_resubmit_hint: "Update your profile below and submit your application again.",
    resubmit: "Resubmit application", resubmitted: "Application sent — under review.",
    upload_photo: "Profile photo", upload_hint: "JPG, PNG or WEBP · 5 MB max",
    upload_ok: "Photo updated", upload_type_err: "Please choose an image",
    upload_size_err: "Image must be under 5 MB",
    // Social proof / trust
    rating_new: "New", verified: "Verified", verified_tip: "Identity and credentials verified by Refine Touch USA",
    testimonials_title: "What our clients say", testimonials_sub: "Real reviews from U.S. clients who booked French experts through Refine Touch.",
    about_service: "About", vetted_title: "Meet our vetted pros",
    vetted_sub: "Every provider is hand-selected: identity, credentials, insurance and reviews are checked before going live.",
    vetted_1_t: "Identity verified", vetted_1_d: "Government ID and U.S. work authorization checked for every provider.",
    vetted_2_t: "French expertise", vetted_2_d: "Training, diplomas and professional references reviewed by our team.",
    vetted_3_t: "Protected payment", vetted_3_d: "You pay securely and the provider is only paid once the service is delivered.",
    vetted_4_t: "Satisfaction guaranteed", vetted_4_d: "Flexible cancellation and refunds under our policy if anything goes wrong.",
    stats_providers: "vetted experts", stats_reviews: "client reviews", stats_rating: "average rating", stats_bookings: "services delivered",
    partners_title: "Our partners", partners_sub: "They trust us and support the French community across the United States.",
    faq_title: "Frequently asked questions",
    faq_1_q: "How are providers vetted?", faq_1_a: "Every application is reviewed by hand: identity, credentials, experience and portfolio. Only approved profiles appear on the site.",
    faq_2_q: "What currency are prices in?", faq_2_a: "All prices are in U.S. dollars (USD), applicable taxes included unless stated otherwise.",
    faq_3_q: "Can I cancel a booking?", faq_3_a: "Yes. Cancellation is free up to 48 hours before the service. See our cancellation & refund policy for details.",
    faq_4_q: "When does the provider get paid?", faq_4_a: "Your payment is held securely by Refine Touch and released to the provider once the service is completed. Refine Touch keeps a 15% commission.",
    faq_5_q: "Do providers speak English?", faq_5_a: "Yes, all our experts are bilingual French / English so you can be served in the language you prefer.",
    legal_refund: "Cancellation & Refunds",
    popular_searches: "Popular searches", hero_location_all: "All cities",
    book_service_top: "Book a service", notify_title: "Not in your city yet?",
    notify_sub: "Leave your email and we'll let you know the moment we launch in your city.",
    notify_city_ph: "Choose a city", notify_email_ph: "you@email.com", notify_btn: "Notify me",
    notify_ok: "Thanks! We'll notify you when we launch.", notify_err: "Please enter a valid email and a city.",
    waitlist_tab: "Waitlist", waitlist_title: "“Notify me” signups", waitlist_none: "No signups yet.",
    waitlist_city: "City", waitlist_email: "Email", waitlist_date: "Date",
  },
};

// Pick a language-specific field from a data record.
// Convention: primary field is EN, `${field}_fr` is French.
export const tr = (obj, field, lang) => {
  if (!obj) return "";
  if (lang === "fr") return obj[`${field}_fr`] || obj[field] || "";
  return obj[field] || obj[`${field}_fr`] || "";
};

const I18nCtx = createContext(null);

export function I18nProvider({ children }) {
  const [lang, setLang] = useState(() => {
    const saved = localStorage.getItem("rt_lang");
    if (saved) return saved;
    // First visit: prefer French only if the browser language starts with "fr"
    const nav = (typeof navigator !== "undefined" && (navigator.language || navigator.languages?.[0])) || "";
    return nav.toLowerCase().startsWith("fr") ? "fr" : "en";
  });
  const change = (l) => { localStorage.setItem("rt_lang", l); setLang(l); };
  const t = (k) => dict[lang][k] || k;
  return <I18nCtx.Provider value={{ lang, t, setLang: change }}>{children}</I18nCtx.Provider>;
}

export const useI18n = () => useContext(I18nCtx);
export const catName = (cat, lang) => cat ? (lang === "fr" ? cat.name_fr : cat.name_en) : "";
